import List from './List.vue'
import Form from './Form.vue'

export default {
  install (Vue) {
    Vue.component('email-groups-list', List)
    Vue.component('email-groups-form', Form)
  }
}



// WEBPACK FOOTER //
// ./src/components/email-groups/index.js